import MainLayout from '@/common/components/layouts/MainLayout';
import ShowIncidentParticipantsDataCard from '@/common/components/showIncidentParticipantsDataCard/ShowIncidentParticipantsDataCard';
import { showIncidentParticipantsData } from '@/common/components/showIncidentParticipantsDataCard/ShowIncidentParticipantsDataCard.type';
import LoadingPage from '@/common/pages/LoadingPage';
import CarTab from '@/modules/adjusterReportModules/IncidentParticipants/assets/icons/carTab.svg?react';
import UserTab from '@/modules/adjusterReportModules/IncidentParticipants/assets/icons/userTab.svg?react';
import SwitchTab from '@/modules/adjusterReportModules/IncidentParticipants/components/common/SwitchTab';
import { getBodyOwnerUserInformationQueryOptions } from '@/modules/adjusterReportModules/Insurer-information/queries/getBodyOwnerUserInformation/getBodyOwnerUserInformationQueryOptions';
import { getShowDriverUserInformationQueryOptions } from '@/modules/adjusterReportModules/Insurer-information/queries/getShowBodyDriverUserInformation/getShowDriverUserInformationQueryOptions';
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { Box, Flex } from 'styled-system/jsx';

export default () => {
  return (
    <MainLayout title="بیمه گذار / راننده - مالک" header="titleHeader">
      <ShowBodyDriverOwnerData />
    </MainLayout>
  );
};
const ShowBodyDriverOwnerData = () => {
  const { id } = useParams();
  const [activeTab, setActiveTab] = useState(1);

  const { data: driverInfoData, isPending: isPendingDriver } = useQuery(
    getShowDriverUserInformationQueryOptions({
      id: Number(id),
    }),
  );
  const { data: ownerInfoData, isPending: isPendingOwner } = useQuery(
    getBodyOwnerUserInformationQueryOptions(+id!),
  );

  if (isPendingDriver && isPendingOwner) {
    return <LoadingPage />;
  }

  const tabs = [
    {
      title: 'مشخصات راننده',
      activeTabIndex: 1,
      icon: <CarTab stroke="currentColor" />,
    },
    {
      title: 'مشخصات مالک',
      activeTabIndex: 2,
      icon: <UserTab stroke="currentColor" />,
    },
  ];
  return (
    <Box pt={24}>
      <SwitchTab
        activeTab={1}
        tabs={tabs}
        getActiveTab={(activeTab: number) => setActiveTab(activeTab)}
      />
      <Box mt={16}>
        {activeTab === 1 && (
          <Flex direction="column" gap={16} marginBottom={'30px'}>
            <ShowIncidentParticipantsDataCard
              title="اطلاعات پایه"
              data={driverInfoData?.personal_information ?? []}
            />
            <ShowIncidentParticipantsDataCard
              title="اطلاعات گواهینامه"
              data={driverInfoData?.certificate_information ?? []}
            />
            <ShowIncidentParticipantsDataCard
              title="اطلاعات تماس"
              data={driverInfoData?.contact_information ?? []}
            />
          </Flex>
        )}
        {activeTab === 2 && (
          <Flex direction="column" gap={16} marginBottom={'30px'}>
            <ShowIncidentParticipantsDataCard
              title="اطلاعات پایه"
              data={
                (ownerInfoData?.mappedData
                  .personal_information as showIncidentParticipantsData[]) ?? []
              }
            />
            <ShowIncidentParticipantsDataCard
              title="اطلاعات تماس"
              data={
                (ownerInfoData?.mappedData
                  .contact as showIncidentParticipantsData[]) ?? []
              }
            />
          </Flex>
        )}
      </Box>
    </Box>
  );
};
